// @ts-nocheck
import Vue from 'vue';
import App from './App.vue';

import Vuex from 'vuex';
import 'es6-promise/auto';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './vuex/store';
import * as FullStory from '@fullstory/browser';
import './validation';
import './plugins/axios';
import Environment from './scripts/environment';
import { Intercom } from "@intercom/messenger-js-sdk";

import { runFullStoryIntercomFrustration } from './scripts/customCommunicationPlatformHelpers';

// IE11 compatibility?
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import VueGtag from 'vue-gtag';

import Loading from '@/components/shared/Loading.vue';

import PolicyStatus from '@/components/shared/PolicyStatus.vue';

import { VTextField } from 'vuetify/lib';

// @ts-ignore
import VCurrencyField from 'v-currency-field';

import moment from 'moment';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import ToastCloseButton from '@/components/shared/ToastCloseButton.vue';

import hub from '@/plugins/webapp-hub.js';

declare module 'vue/types/vue' {
  interface Vue {
    $http: any,
    $httpSBIX: any,
    $httpIdentity: any,
    $httpMoratorium: any,
    $validator: any,
    $gtag: any
  }
}

Vue.config.productionTip = false;
Vue.use(VueGtag, {
  config: {
    id: Environment.GOOGLE_ANALYTICS_ID,
    params: {
      send_page_view: false
      // debug_mode: true,
    }
  },
  pageTrackerEnabled: false
});

Vue.config.errorHandler = (err, vm, info) => {
  Vue.util.warn(`Error in ${info}: "${err.toString()}"`, vm);
  console.error(err);

  Vue.prototype.$gtag.exception({
    'page_location': window.location.href,
    'description': err
  });

  if (Environment.environment != 'localhost' && Environment.environment != 'development') {
    // @ts-ignore
    hj('event', err.toString());
  }
};
Vue.component('Loading', Loading);
Vue.component('PolicyStatus', PolicyStatus);
Vue.component('v-text-field', VTextField);
Vue.use(VCurrencyField);
Vue.filter('formatDate', function (value: any) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY');
  }
});

var fullstoryOrgId = Environment.FULLSTORY_ID;
if (Environment.environment === 'localhost') {
  fullstoryOrgId = process.env.VUE_APP_FULLSTORY_ORGID;
}
if (fullstoryOrgId) {
  FullStory.init({
    orgId: fullstoryOrgId,
    devMode: false // allow the FullStory id existence be the driver for if FullStory is enabled or not...
  });
  Vue.prototype.$FullStory = FullStory;
}

var intercomId = Environment.INTERCOM_ID;
if (Environment.environment === 'localhost') {
  intercomId = process.env.VUE_APP_INTERCOM_ID;
}
if (intercomId) {
  Intercom({
    app_id: intercomId,
    custom_launcher_selector: '.intercom_button',
    hide_default_launcher: true
  });

  runFullStoryIntercomFrustration();
}
// const toastContainer = document.querySelector('.v-main__wrap');
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true,
  position: "bottom-center",
  timeout: false,
  closeOnClick: true,
  draggable: false,
  hideProgressBar: true,
  closeButton: ToastCloseButton,
  icon: false,
  toastClassName: 'amwins-toast'
  // container: toastContainer
});
Vue.use(hub);

Vue.directive('outside-click', {
  bind (el, binding) {
    el.__clickOutsideHandler__ = (event: Event) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        if (typeof binding.value === 'function') {
          binding.value(event);
        }
      }
    };
    document.addEventListener('click', el.__clickOutsideHandler__);
  },
  unbind (el) {
    document.removeEventListener('click', el.__clickOutsideHandler__);
    el.__clickOutsideHandler__ = null;
  }
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
